var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.36c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78 21.75c-3.43 0-4.53-1.09-4.53-4.48v-6.99c0-2.69.61-4.28 3.71-4.46.26-.01.53-.02.82-.02h9.44c3.43 0 4.53 1.09 4.53 4.48v7.15c-.04 3.27-1.14 4.32-4.53 4.32H5.78zM5.03 7.32c-1.79.11-2.28.49-2.28 2.96v6.99c0 2.56.42 2.98 3.03 2.98h9.44c2.58 0 3-.4 3.03-2.83v-7.14c0-2.56-.42-2.98-3.03-2.98H5.78c-.27 0-.52.01-.75.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 17.98a.756.756 0 0 1-.24-.55v-7.15c0-2.56-.42-2.98-3.03-2.98H5.78c-.27 0-.52.01-.75.02-.2.01-.4-.07-.55-.21a.747.747 0 0 1-.23-.55c.04-3.26 1.14-4.31 4.53-4.31h9.44c3.43 0 4.53 1.09 4.53 4.48v6.99c0 2.69-.61 4.28-3.71 4.46H19c-.19 0-.38-.07-.51-.2zM15.22 5.8c3.43 0 4.53 1.09 4.53 4.48v6.32c1.16-.21 1.5-.81 1.5-2.88V6.73c0-2.56-.42-2.98-3.03-2.98H8.78c-2.28 0-2.87.31-3 2.05h9.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24 18.56c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.72a.749.749 0 1 1 0 1.5H5.24zM9.11 18.56c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.44a.749.749 0 1 1 0 1.5H9.11z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCards);
export default __webpack_public_path__ + "static/media/vuesax-outline-cards.1539007de8f2c0a4d98807e08d20d596.svg";
export { ForwardRef as ReactComponent };